/// <amd-module name="SuiteCommerce.StockNotifications.Item.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Item.Collection", ["require", "exports", "underscore", "Backbone", "SuiteCommerce.StockNotifications.Utils", "SuiteCommerce.StockNotifications.Configuration", "SuiteCommerce.StockNotifications.Item.Model"], function (require, exports, _, Backbone_1, Utils_1, Configuration_1, Item_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemCollection = void 0;
    var ItemCollection = /** @class */ (function (_super) {
        __extends(ItemCollection, _super);
        function ItemCollection(models, options) {
            var _this = _super.call(this, models, options) || this;
            _this.model = Item_Model_1.ItemModel;
            if (options) {
                _this.environment = options.environment;
                _this.ids = options.ids || [];
            }
            return _this;
        }
        Object.defineProperty(ItemCollection.prototype, "url", {
            get: function () {
                return Utils_1.Utils.addParamsToUrl('/api/items', this.searchApiParams);
            },
            enumerable: false,
            configurable: true
        });
        ItemCollection.prototype.fetch = function (options) {
            var _this = this;
            var xhr = _super.prototype.fetch.call(this, options);
            return xhr.done(function () {
                _this.models.forEach(function (item) {
                    if (item.isMatrixParent) {
                        var parent_1 = item;
                        _this.models.forEach(function (child) {
                            var itemOptionsDetail = child.get('itemoptions_detail');
                            if (itemOptionsDetail && itemOptionsDetail.parentid === parent_1.internalId) {
                                child.parentItem = item;
                            }
                        });
                    }
                });
            });
        };
        Object.defineProperty(ItemCollection.prototype, "searchApiParams", {
            get: function () {
                return _({}).extend(this.searchApiMasterOptions, this.sessionSearchApiParams, this.itemsParams);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemCollection.prototype, "searchApiMasterOptions", {
            get: function () {
                return Configuration_1.Configuration.get('searchApiMasterOptions.itemDetails') || {};
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemCollection.prototype, "sessionSearchApiParams", {
            get: function () {
                var searchApiParams = {};
                var sessionInfo = this.environment.getSession();
                var locale = (sessionInfo.language && sessionInfo.language.locale) || '';
                var language = '';
                var country = '';
                var currency = (sessionInfo.currency && sessionInfo.currency.code) || '';
                var priceLevel = sessionInfo.priceLevel || '';
                var localeTokens;
                if (locale.indexOf('_') >= 0) {
                    localeTokens = locale.split('_');
                    language = localeTokens[0];
                    country = localeTokens[1];
                }
                else {
                    language = locale;
                }
                // SET API PARAMS
                if (language) {
                    searchApiParams.language = language;
                }
                if (country) {
                    searchApiParams.country = country;
                }
                if (currency) {
                    searchApiParams.currency = currency;
                }
                searchApiParams.pricelevel = priceLevel;
                // No cache
                if (Utils_1.Utils.parseUrlOptions(window.location.search).nocache === 'T') {
                    searchApiParams.nocache = 'T';
                }
                return searchApiParams;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ItemCollection.prototype, "itemsParams", {
            get: function () {
                return {
                    id: this.ids.join(',')
                };
            },
            enumerable: false,
            configurable: true
        });
        ItemCollection.prototype.parse = function (response) {
            return _(response.items).compact() || null;
        };
        return ItemCollection;
    }(Backbone_1.Collection));
    exports.ItemCollection = ItemCollection;
});
